/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const mainVisSwiper = () => {
		const sliderElement = document.querySelector('.top-mainVis.splide');
		if (!sliderElement) return;

		// スライド要素の数を確認
		const slides = sliderElement.querySelectorAll('.splide__slide');
		const slideCount = slides.length;

		// 1枚の場合はスライダー機能を無効にする
		const isMultipleSlides = slideCount > 1;

		const splide = new Splide('.top-mainVis.splide', {
			type: isMultipleSlides ? 'loop' : 'slide',
			perPage: 1,
			autoplay: isMultipleSlides,
			interval: 5000,
			speed: 500,
			arrows: isMultipleSlides,
			pagination: isMultipleSlides,
			paginationKeyboard: isMultipleSlides,
			autoWidth: true,
		}).mount();

		// 一時停止ボタンの制御
		const pauseButton = document.querySelector('.slider-pause');
		if (pauseButton && isMultipleSlides) {
			let isPaused = false;

			pauseButton.addEventListener('click', () => {
				if (isPaused) {
					splide.Components.Autoplay.play();
					isPaused = false;
					pauseButton.classList.remove('is-paused');
				} else {
					splide.Components.Autoplay.pause();
					isPaused = true;
					pauseButton.classList.add('is-paused');
				}
			});
		} else if (pauseButton && !isMultipleSlides) {
			// 1枚の場合は一時停止ボタンを非表示にする
			pauseButton.style.display = 'none';
		}
	};

	const showTopBg = () => {
		const targetElements = document.querySelectorAll('.js-top-bg');

		if (targetElements.length === 0) return;

		// 要素の位置を詳細に確認
		targetElements.forEach((element, index) => {
			const rect = element.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			const isFullyVisible = rect.top >= 0 && rect.bottom <= windowHeight;

			// 初期状態で要素が完全に画面内にある場合はすぐにクラスを付与
			if (isFullyVisible) {
				element.classList.add('is-show');
			}
		});

		const observerOptions = {
			threshold: 1.0, // 要素が100%見えている状態でトリガー
			rootMargin: '0px'
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting && entry.intersectionRatio >= 1.0) {
					entry.target.classList.add('is-show');
				}
			});
		}, observerOptions);

		targetElements.forEach((element) => {
			observer.observe(element);
		});

		// スクロールイベントでも確認（要素が完全に画面内に入った時点で発火）
		window.addEventListener('scroll', () => {
			targetElements.forEach((element) => {
				if (!element.classList.contains('is-show')) {
					const rect = element.getBoundingClientRect();
					const isFullyVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
					if (isFullyVisible) {
						element.classList.add('is-show');
					}
				}
			});
		});
	};

	const commonSplideInit = () => {
		const isOverflowing = (splide) => {
			const Layout = splide.Components.Layout;
			return Layout.isOverflow();
		};
		const sliders = document.querySelectorAll('.js-common-slider');

		sliders.forEach((slider) => {
			const gap = slider.dataset.gap || '16px';

			const splide = new Splide(slider, {
				type: 'loop',
				autoplay: false,
				arrows: true,
				pagination: true,
				autoWidth: true,
				gap: gap,
				drag: true,
				breakpoints: {
					768: {
						gap: 16,
					},
				},
			});

			let prevOverflow = null;

			const updateByOverflow = () => {
				const overflow = isOverflowing(splide);

				// 状態が変わった時だけ更新
				if (overflow === prevOverflow) return;

				prevOverflow = overflow;

				splide.options = {
					type: overflow ? 'loop' : 'slide',
					drag: overflow,
					arrows: overflow,
					pagination: overflow,
				};

				splide.refresh();
			};

			// mounted の1回目だけ確実に実行
			splide.on('mounted', updateByOverflow);

			// resize 時は requestAnimationFrame で1フレ遅らせる
			splide.on('resized', () => {
				requestAnimationFrame(updateByOverflow);
			});

			splide.mount();
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		mainVisSwiper();
		showTopBg();
		commonSplideInit();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
